import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';

export function getFieldUnit(customField: TCustomField): string {
  const type = customField.outputType || customField.type;

  switch (type) {
    case ECustomFieldType.COST:
      return customField.currencySymbol;
    case ECustomFieldType.NUMBERS:
      return customField.unit || '';
    case ECustomFieldType.PERCENTAGE:
      return '%';
    default:
      return '';
  }
}
